var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownOg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right 1",
    clipPath: "url(#clip0_413_60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7837 8.32705C18.1018 7.99424 18.0647 7.48886 17.701 7.19795C17.337 6.90732 16.7842 6.94131 16.466 7.27382L11.0001 12.9855L5.53392 7.27353C5.21573 6.94072 4.66299 6.90703 4.2993 7.19765C3.93529 7.48857 3.89812 7.99394 4.21631 8.32675L10.3413 14.7267C10.5073 14.9004 10.7476 15 11.0001 15C11.2526 15 11.4926 14.9004 11.659 14.7267L17.7837 8.32705Z",
    fill: "url(#paint0_linear_413_60)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_60",
    x1: -6.09616,
    y1: 14.7531,
    x2: -5.48684,
    y2: 5.05519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(22.5 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownOg);
export default __webpack_public_path__ + "static/media/arrow-down-og.d25ef0532eb7edc60504521a7e4ad4c0.svg";
export { ForwardRef as ReactComponent };